export default "__VITE_ASSET__CROHvQ3Y__"